export default "__VITE_ASSET__McfU5hlZ__"